import { optimizationStrategyApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const OPTIMIZATION_STRATEGY_ACTION_TYPE = createNamedActions('optimizationStrategies', {
  GET_STRATEGIES: 'GET_STRATEGIES',
  CREATE_STRATEGY: 'CREATE_STRATEGY',
  UPDATE_STRATEGY: 'UPDATE_STRATEGY',
  DELETE_STRATEGY: 'DELETE_STRATEGY',
  SET_ACTIVE_STRATEGY: 'SET_ACTIVE_STRATEGY',
});

export const getStrategiesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await optimizationStrategyApi.getStrategies();

  return dispatch({
    type: OPTIMIZATION_STRATEGY_ACTION_TYPE.GET_STRATEGIES,
    payload: data,
  });
});

export const createStrategyAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await optimizationStrategyApi.createStrategy(params);

  return dispatch({
    type: OPTIMIZATION_STRATEGY_ACTION_TYPE.CREATE_STRATEGY,
    payload: data,
  });
});

export const updateStrategyAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await optimizationStrategyApi.updateStrategy(params);

  return dispatch({
    type: OPTIMIZATION_STRATEGY_ACTION_TYPE.UPDATE_STRATEGY,
    payload: data,
  });
});

export const deleteStrategyAction = catchAsyncActionError(({ strategyId }) => async dispatch => {
  await optimizationStrategyApi.deleteStrategy({ strategyId });

  return dispatch({
    type: OPTIMIZATION_STRATEGY_ACTION_TYPE.DELETE_STRATEGY,
    meta: { strategyId },
  });
});

export const setActiveStrategyAction = catchAsyncActionError(({ strategyId }) => async dispatch => {
  const { data } = await optimizationStrategyApi.setActiveStrategy({ strategyId });

  return dispatch({
    type: OPTIMIZATION_STRATEGY_ACTION_TYPE.SET_ACTIVE_STRATEGY,
    payload: data,
    meta: { strategyId },
  });
});
